import * as React from 'react';
const SvgClock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 6a1 1 0 0 1 1 1v5.086l2.207 2.207a1 1 0 0 1-1.414 1.414L11.586 13.5A2 2 0 0 1 11 12.086V7a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClock;
